import React from 'react';
import { PropTypes } from 'prop-types';

import WhdStatementLineValidationResult from 'components/WhdStatementLineValidationResult';

export function buildDescription({ codeDescription, context }) {
  // check description for dynamic parts like ${...}
  const interpolationParts = codeDescription.match(/\${[^}\r\n]*}/g);
  if (interpolationParts && interpolationParts.length) {
    let result = codeDescription;
    interpolationParts.forEach((template) => {
      if (template != null) {
        const matches = template.match(/\${([^}]*)}/);
        const contextField = matches != null && matches[1];
        if (contextField != null) {
          result = result.split(template).join(context[contextField]);
        }
      }
    });
    return result;
  }
  return codeDescription;
}

const WhdStatementValidationResult = ({
  result
}) => (
  /* eslint-disable max-len, react/no-array-index-key */
  <div className="single-validation-result whd-validation-result">
    <div className="result-header whd-validation-header">
      Withholding Statement Validation Result
    </div>
    { result.valid && <h2 className="valid">Valid</h2> }
    { !result.valid && <h2 className="invalid">Invalid</h2> }
    { result.valid && <div>
      <p>The Withholding Statement validation is complete.</p>
      <p>It has been reliably associated with the Intermediary&apos;s W-8IMY Form,
        and provides sufficient information to allocate payments.
      </p>
    </div> }
    { ((result.rejections != null && result.rejections.length !== 0) || (result.warnings != null && result.warnings.length !== 0)) && <h3>{ result.name }</h3> }
    { result.rejections != null && result.rejections.length !== 0 && <div className="result-block">
      <div className="heading-row">Reasons for rejection:</div>
      <div className="reasons-for-rejection-list">
        <ul>
          { result.rejections.map(rejection => rejection != null && (
            <li key={ rejection.key }>
              <em>{ buildDescription(rejection) }</em>
              &nbsp;(<strong>{ rejection.code }</strong>)
            </li>
          )) }
        </ul>
      </div>
    </div> }
    { result.warnings != null && result.warnings.length !== 0 && <div className="result-block">
      <div className="heading-row">Warnings:</div>
      <div className="red-flags-and-recs-list">
        <ul>
          { result.warnings.filter(w => w.code.indexOf('WRN') > -1).map(warning => warning != null && (
            <li
              key={ warning.key }
              className="red-flag"
            >
              <em>{ buildDescription(warning) }</em>
              &nbsp;(<strong>{ warning.code }</strong>)
            </li>
          )) }
          { result.warnings.filter(w => w.code.indexOf('WRN') === -1).map(warning => warning != null && (
            <li
              key={ warning.key }
              className="recommendation"
            >
              <em>{ buildDescription(warning) }</em>
              &nbsp;(<strong>{ warning.code }</strong>)
            </li>
          )) }
        </ul>
      </div>
    </div> }
    { result.lines != null && [...result.lines].map((x, i) => x != null
      && (<WhdStatementLineValidationResult key={ result.lines[i].key } result={ result.lines[i] } />)) }
  </div>
  /* eslint-enable max-len, react/no-array-index-key */
);

WhdStatementValidationResult.propTypes = {
  result: PropTypes.shape().isRequired
};

export default WhdStatementValidationResult;
